import jwt_decode from "jwt-decode";
import * as Yup from "yup";
import "./index.scss";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import { getSkillsData } from "../../../store/apiCalls/profilesetup";
import { UploadMedia } from "../../../store/apiCalls/profilesetup";
import { SERVER_URL } from "../../../config";
import { Dropdown, Modal } from "react-bootstrap";
import Header from "../../../layout/header";
import Tabs from "../../../components/common/Tabs";
import Form from "../../../components/common/Form";
import About from "../../../components/profileSetup/About/";
import SocialPresence from "../../../components/profileSetup/socialPresence";
import Services from "../../../components/profileSetup/Services";
import PaymentSetup from "../../../components/profileSetup/PaymentSetup";
import "../../../assets/scss/modules/_layoutGlobal.scss";
import "../../../assets/scss/personal_detail.scss";
import "../../../assets/scss/components/_formsGlobal.scss";
import "../../../assets/scss/components/_buttonsGlobal.scss";
import "../../../assets/scss/base/themecomponents/_resetGlobal.scss";
import "../../../assets/font_icons/style.scss";
import dribbleIcon from "../../../assets/img/icons/dribble.png";
import vimeoIcon from "../../../assets/img/icons/vimeo.png";
import youtubeIcon from "../../../assets/img/icons/youtube.png";
import behanceIcon from "../../../svg/behance.svg";
import mediumIcon from "../../../svg/medium.svg";
import canvaIcon from "../../../svg/canva.svg";
import Logout from "../../../svg/logout.svg";

import {
  validateEmail,
  validatePhoneNumber,
  checkUrl,
  isPublishable,
  unPublishToolTip,
  ProfessionalUrlCheck,
} from "../../../utils";
import {
  FetchVendorDetails,
  OnAboutSubmit,
  OnMediaDelete,
  OnPancardDelete,
  OnUpload,
} from "./queries.js";
import StateJson from "../../../constants/States.json";
import { phoneField } from "../../../constants";
import { GetVendorDetails } from "../../../store/apiCalls/profilesetup";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/common/Button";
import { SHOW_ERROR } from "../../../store/actions/profileActions";
import UpArrowQuestion from "../../../components/commonComponents/upArrowQuestion";
import SavedModal from "./SavedModal";

const socialPlatforms = ["twitter", "instagram", "facebook"];
const urlDefaultError = { twitter: "", instagram: "", facebook: "" };
const iconMapping = {
  dribble: dribbleIcon,
  medium: mediumIcon,
  vimeo: vimeoIcon,
  canva: canvaIcon,
  behance: behanceIcon,
  youtube: youtubeIcon,
};

const ProfileSetup = () => {
  const validateForm = Yup.object({
    profile: Yup.string().required("Please upload Profile Image"),
    title: Yup.string().required("Please select title"),
    phoneNumber: Yup.string().required("Please enter Mobile Number"),
    email: Yup.string().required("Please enter Email ID")
  });

  const navigate = useNavigate();
  const token = localStorage.getItem("vendorToken");
  const { id } = token ? jwt_decode(token) : "";
  const [savedModal, setSavedModal] = useState(false);
  const [urlErrors, setUrlError] = useState(urlDefaultError);
  const [errors, setErrors] = useState({});
  const [profileDetails, setProfileDetails] = useState({
    professionalPresence: [
      {
        image: dribbleIcon,
        professionalKey: "dribble",
        link: "",
        subscribe: false,
        linkName: "Dribble",
      },
      {
        image: vimeoIcon,
        professionalKey: "vimeo",
        link: "",
        subscribe: false,
        linkName: "Vimeo",
      },
      {
        image: youtubeIcon,
        professionalKey: "youtube",
        link: "",
        subscribe: false,
        linkName: "Youtube",
      },
    ],
  });
  const [commonAddFields, setCommonAddFields] = useState({
    languagesKnown: [{ id: "language1", value: "" }],
    personalWebsites: [{ id: "personalWebsite1", value: "" }],
  });

  const [webcamImage, setWebcamImage] = useState("");
  const [openWebcam, setOpenWebcam] = useState(false);
  const [uploadedImage, setUploadedImage] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [imageFile, SetImageFile] = useState({});
  const [profile, setProfile] = useState("");
  const [openTab, setOpenTab] = useState(["About"]);
  const [activeTab, setActiveTab] = useState("personal");
  const TabsHeading = ["About", "Services", "Payment Setup"];
  const hiddenFileInput = useRef();
  const [servicesOffered, setServicesOffered] = useState([]);
  const [services, setServices] = useState({});
  const [phone, setPhone] = useState("");
  const [openProfilePage, setOpenprofilePage] = useState(false);
  const [imageDisplayModalOpen, setImageDisplayModalOpen] = useState(false);
  const [openImageUpload, setOpenImageUpload] = useState(false);
  const [imageDisplayModal, setImageDisplayModal] = useState(false);
  const [currentService, setCurrentService] = useState({});
  const [samplesUpload, setSamplesUpload] = useState(true);
  const isSetupProfile = useSelector(
    (state) => state?.LoginReducer?.user?.isSetupProfile ?? null
  );
  const dispatch = useDispatch();
  const DefaultServiceCount = [
    {
      servicesuuid: "service1",
      serviceType: "Copy Editing",
      experience: "",
      serviceOfferedId: "",
      skills: [],
      rates: [
        {
          levelNumber: 1,
          min: 100,
          max: 200,
          levelChecked: false,
          level: { min: "", max: "" },
        },
        {
          levelNumber: 2,
          min: 150,
          max: 300,
          levelChecked: false,
          level: { min: "", max: "" },
        },
      ],
      samples: [],
      vendorId: id,
      pancardNumber: "",
      GSTNumber: "",
      uploadPancard: "",
    },
  ];
  const [servicesCount, setServicesCount] = useState(DefaultServiceCount);

  useEffect(() => {
    setOpenprofilePage(isSetupProfile);
    // eslint-disable-next-line
    fetchSkills();
  }, []);

  const fetchSkills = async () => {
    const params = { id: id };
    const header = { Authorization: `Bearer ${token}` };
    const skillResp = await getSkillsData(params, header);
    if (skillResp.data.success) {
      dispatch({ type: "SET_SKILLS_DATA", payload: skillResp.data.data || [] });
    }
  };

  const handleUploadImage = (event) => {
    setWebcamImage("");
    setOpenWebcam(false);
    let reader = new FileReader();
    let file = event.target.files[0];
    reader.readAsDataURL(file);
    if (file.size < 50000000) {
      reader.onloadend = () => {
        setUploadedImage(reader.result);
        SetImageFile(file);
        // setFormError({ profile: '' })
        dispatch({ type: SHOW_ERROR, payload: { message: "", type: "" } });
      };
    } else {
      // alert("this is error ")
      dispatch({
        type: SHOW_ERROR,
        payload: { message: "FileSize is more then 50 mb", type: "image" },
      });
      // setFormError({ ...formError, profile: 'Image size should be less than 50kb.' })
    }
  };

  const SucessHandlerAbout = (sucess, data) => {
    console.log(sucess)
    // setOpenTab([...openTab, "Services"]);
    // return setActiveTab("Services");
    // return toast.success(sucess.data.msg);
  };
  // new code
  const webcamRef = useRef(null);

  const capture = useCallback(() => {
    const pictureSrc = webcamRef.current.getScreenshot();
    setWebcamImage(pictureSrc);
    setUploadedImage("");
  }, []);

  const handleWebcam = () => {
    setWebcamImage("");
    setUploadedImage("");
    setOpenWebcam(!openWebcam);
  };

  const sucessHandler_Vendor = (fetchedData) => {
    const fetchedApiData = fetchedData?.data?.data;
    const ChangedData = JSON.parse(JSON.stringify(fetchedApiData));
    ChangedData.fullname = fetchedApiData?.fullName;
    ChangedData.primaryEmail = fetchedApiData?.email;
    ChangedData.professionalSummary =
      fetchedApiData?.aboutId?.professionalSummary;
    ChangedData.profilePicture = fetchedApiData?.aboutId?.profilePicture;
    ChangedData.gender = fetchedApiData?.aboutId?.gender;
    ChangedData.secondaryEmail = fetchedApiData?.aboutId?.secondaryEmail;
    ChangedData.twitter = fetchedApiData?.aboutId?.socialLinks?.twitter;
    ChangedData.facebook = fetchedApiData?.aboutId?.socialLinks?.facebook;
    // ChangedData.dribble =
    //   fetchedApiData?.aboutId?.professionalPresence?.dribble;
    ChangedData.instagram = fetchedApiData?.aboutId?.socialLinks?.instagram;
    // ChangedData.vimeo = fetchedApiData?.aboutId?.professionalPresence?.vimeo;
    ChangedData.apartment_house_no =
      fetchedApiData?.aboutId?.mailingAddress?.apartment_house_no;
    ChangedData.state = fetchedApiData?.aboutId?.mailingAddress?.state;
    ChangedData.city = fetchedApiData?.aboutId?.mailingAddress?.city;
    ChangedData.socialLinks = fetchedApiData?.aboutId?.socialLinks;
    ChangedData.pincode = fetchedApiData?.aboutId?.mailingAddress?.pincode;
    ChangedData.languagesKnown = fetchedApiData?.aboutId?.languagesKnown || [
      "",
    ];

    ChangedData.personalWebsites = fetchedApiData?.aboutId?.website?.map(
      (web, ind) => {
        return { id: ind, value: web };
      }
    );

    if (ChangedData?.personalWebsites?.length < 1) {
      ChangedData.personalWebsites = [{ id: "personalWebsite1", value: "" }];
    }

    ChangedData.professionalPresence =
      profileDetails?.professionalPresence?.map((item, index) => {
        return item.professionalKey ===
          fetchedApiData?.aboutId?.professionalPresence?.[index]
            ?.professionalKey
          ? {
              ...item,
              link: fetchedApiData?.aboutId?.professionalPresence?.[index]
                ?.link,
              subscribe:
                fetchedApiData?.aboutId?.professionalPresence?.[index]
                  ?.subscribe,
            }
          : item;
      });

    setPhone(fetchedApiData?.phoneNumber);
    setProfileDetails(ChangedData);
    setProfile(ChangedData.profilePicture);
    setCommonAddFields({
      personalWebsites: ChangedData.personalWebsites || [
        { id: "personalWebsite1", value: "" },
      ],
    });
    const newData = fetchedApiData?.serviceId.map((val) => {
      if (
        ["Graphics & Design", "Book Cover Design"].indexOf(
          val?.serviceOfferedId?.serviceName
        ) > -1
      ) {
        val.rateChecked =
          val?.rates?.find((rt) => rt?.level?.min > 0 || rt?.level?.max > 0) ||
          false;
        val.rates = val?.rates?.map((rt) => {
          return {
            ...rt,
            levelChecked: rt?.level?.min || rt?.level?.max ? true : false,
          };
        });
        val.not_have_any_samples = false;
        val.useOfOriginalChecked =
          val?.useOfOriginal?.find(
            (us) => us?.level?.min > 0 || us?.level?.max > 0
          ) || false;
        val.useOfOriginal = val?.useOfOriginal?.map((us) => {
          return {
            ...us,
            levelChecked: us?.level?.min || us?.level?.max ? true : false,
          };
        });
        val.tableDesignChecked =
          val?.tableDesign?.find(
            (td) => td?.level?.min > 0 || td?.level?.max > 0
          ) || false;
        val.tableDesign = val?.tableDesign?.map((td) => {
          return {
            ...td,
            levelChecked: td?.level?.min || td?.level?.max ? true : false,
          };
        });
        val.formulaeChecked =
          val?.formulae?.find(
            (fo) => fo?.level?.min > 0 || fo?.level?.max > 0
          ) || false;
        val.formulae = val?.formulae.map((fo) => {
          return {
            ...fo,
            levelChecked: fo?.level?.min || fo?.level?.max ? true : false,
          };
        });
      }

      if (val.requestForOtherServiceId) {
        val.serviceStatus = val.requestForOtherServiceId.status;
        val.serviceText = val.requestForOtherServiceId.text;
        val.requestForOtherServiceId = val.requestForOtherServiceId._id;
      }

      val.skills = val.skills.map((a) => {
        a.name = a._id;
        return a;
      });
      return {
        ...val,
        skills: val.skills ? val.skills : [],
        not_have_any_samples: val.not_have_any_samples,
        servicesuuid: val?._id || "service1",
        serviceOfferedId: val?.serviceOfferedId?._id,
        serviceType: val?.serviceOfferedId?.serviceName,
        serviceId: val?._id || "",
        rates: val?.rates?.map((rt) => {
          return {
            ...rt,
            levelChecked: rt?.level?.min || rt?.level?.max ? true : false,
          };
        }),
      };
    });
    setServicesCount(newData.length > 0 ? newData : DefaultServiceCount);
  };

  const fetchdata = async () => {
    const params = { id: id };
    const header = { Authorization: `Bearer ${token}` };
    return GetVendorDetails(params, header);
  };
  const { refetch, data } = FetchVendorDetails(fetchdata, sucessHandler_Vendor);
  const [test, setTest] = useState(false);

  useEffect(() => {
    if (data === null || data === undefined || test) {
      return;
    }
    const professionalPresence =
      data?.data?.data?.aboutId?.professionalPresence;

    if (Array.isArray(professionalPresence) === false) {
      return;
    }

    if (
      professionalPresence?.length ===
      profileDetails?.professionalPresence?.length
    ) {
      setTest(true);
      return;
    }

    const updatedProfessional = professionalPresence?.map((ele) => ({
      image: iconMapping[ele?.professionalKey],
      professionalKey: ele?.professionalKey,
      link: ele?.link,
      subscribe: ele?.subscribe,
      linkName:
        ele?.professionalKey[0]?.toUpperCase() + ele?.professionalKey.slice(1),
    }));
    setProfileDetails((pd) => ({
      ...pd,
      professionalPresence: updatedProfessional,
    }));
  }, [data, profileDetails, test]);

  // new code
  const appendURL = (url) => {
    const cloneService = JSON.parse(JSON.stringify(servicesCount));
    const ChangeValue = cloneService?.map((ser, ind) => {
      if (ser.servicesuuid === currentService?.servicesuuid) {
        ser.samples = ser.samples
          ? ser.samples.push({ uploadSamples: "", url: url })
          : [{ uploadSamples: "", url: url }];
        ser.not_have_any_samples = false;
      }
    });
    setServicesCount(ChangeValue);
  };

  const uploadSucessHandler = (sucess) => {
    const cloneService = JSON.parse(JSON.stringify(servicesCount));
    if (
      activeTab === "Services" &&
      samplesUpload &&
      !imageFile?.name &&
      !webcamImage
    ) {
      const currentSer = cloneService.find(
        (a) => a.servicesuuid === currentService.servicesuuid
      );
      if (currentSer) {
        currentSer.samples =
          currentSer.samples && Array.isArray(currentSer.samples)
            ? currentSer.samples.push({
                uploadSamples: sucess?.data?.url,
                url: "",
              })
            : [{ uploadSamples: sucess?.data?.url, url: "" }];
        currentSer.not_have_any_samples = false;
      }
      setServicesCount(cloneService);
    } else if (imageFile?.name || webcamImage) {
      setProfile(sucess?.data?.url);
    } else if (!samplesUpload) {
      const ChangeValue = cloneService?.map((ser) =>
        ser.servicesuuid === currentService?.servicesuuid
          ? {
              ...ser,
              uploadPancard: sucess?.data?.url || "",
            }
          : ser
      );
      setServicesCount(ChangeValue);
    }
    setSamplesUpload(false);
    SetImageFile({});
    setOpenWebcam(false);
    setUploadedImage("");
    setWebcamImage("");
    setOpenImageUpload(false);
    setCurrentService({});
    dispatch({ type: SHOW_ERROR, payload: { message: "", type: "" } });
  };

  const deleteSucessHandler = (sucess) => {
    const cloneService = JSON.parse(JSON.stringify(servicesCount));
    const cloneCurrentService = JSON.parse(JSON.stringify(currentService));
    const deleteImage = cloneService?.map((ser) =>
      ser.servicesuuid === sucess.servicesuuid
        ? {
            ...ser,
            samples: ser.samples.filter(
              (item) =>
                item?.[sucess.keyName] !== sucess?.body?.[sucess.keyName]
            ),
          }
        : ser
    );
    if (cloneCurrentService?.samples) {
      const updateSample = cloneCurrentService.samples.filter(
        (item) => item.uploadSamples !== sucess.uploadSamples
      );
      setCurrentService({ ...currentService, samples: updateSample });
    }

    setServicesCount(deleteImage);
    // }
  };
  const PanDeleteSucessHandler = (sucess) => {
    const cloneService = JSON.parse(JSON.stringify(servicesCount));
    const cloneCurrentService = JSON.parse(JSON.stringify(currentService));
    // if(sucess?.data?.data?.sucess){
    const deletePanCard = cloneService?.map((ser) =>
      ser.serviceId === sucess.serviceId
        ? {
            ...ser,
            uploadPancard: "",
          }
        : ser
    );
    setServicesCount(deletePanCard);
  };

  const { mutate: SubmitAboutTab } = OnAboutSubmit(SucessHandlerAbout);
  // const { mutate: UploadMedia } = OnUpload(uploadSucessHandler);
  const { mutate: DeleteMedia } = OnMediaDelete(deleteSucessHandler);
  const { mutate: DeletePancard } = OnPancardDelete(PanDeleteSucessHandler);

  const validateFields = (profileData = profileDetails, profilePic = profile ) => {
    try {
      validateForm.validateSync(
        { ...profileData, profile: profilePic },
        { abortEarly: false }
      );
      setErrors({});
    } catch (err) {
      setErrors(
        (errors) =>
          err.inner?.reduce(
            (acc, curr) => ({ ...acc, [curr.path]: curr.message }),
            errors
          ) ?? {}
      );
  }}

  const handleSubmitAboutTab = async (e) => {
    e.preventDefault();
    const decoded = token ? jwt_decode(token) : "";
    const requiredParams = { ...profileDetails };
    requiredParams.isSetupProfile = "false";
    requiredParams.vendoreId = decoded?.id;
    requiredParams.profilePicture = profile;
    requiredParams.website = profileDetails.personalWebsites.filter((a) => a);
    requiredParams.currentLocation = profileDetails.city;
    requiredParams.headers = { Authorization: `Bearer ${token}` };
    delete requiredParams.countryCode;
    delete requiredParams.instagram;
    delete requiredParams.facebook;
    delete requiredParams.twitter;
    delete requiredParams.aboutId;
    try {
      if(e.target.textContent !== "SAVE") {
        validateForm.validateSync(
          { ...structuredClone(requiredParams), profile },
          { abortEarly: false }
        )
        setErrors({});
        await SubmitAboutTab(requiredParams, true, "sdfds");
        setOpenTab([...openTab, "Services"]);
        setActiveTab("Services");
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        setErrors({});
        SubmitAboutTab(requiredParams);
        setSavedModal(true);
        window.scrollTo({ top: 0, behavior: "smooth"})
      }
    } catch (err) {
      setErrors(
        (errors) =>
          err.inner?.reduce(
            (acc, curr) => ({ ...acc, [curr.path]: curr.message }),
            errors
          ) ?? {}
      );
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleSelectChange = (value, name) => {
    if (name === "state" && value) {
      profileDetails.city = "";
    }

    if (name === "languagesKnown") {
      if (profileDetails?.[name]?.[0] === "") {
        return setProfileDetails({ ...profileDetails, [name]: [value] });
      } else {
        if (profileDetails?.languagesKnown?.includes(value)) {
          return setProfileDetails({ ...profileDetails });
        }
        return setProfileDetails({
          ...profileDetails,
          [name]: [...profileDetails?.[name], value],
        });
      }
    }

    if (name === "languagesKnown") {
      if (profileDetails?.[name]?.[0] === "") {
        return setProfileDetails({ ...profileDetails, [name]: [value] });
      } else {
        if (profileDetails?.languagesKnown?.includes(value)) {
          return setProfileDetails({ ...profileDetails });
        }
        return setProfileDetails({
          ...profileDetails,
          [name]: [...profileDetails?.[name], value],
        });
      }
    }
    return setProfileDetails({ ...profileDetails, [name]: value });
  };

  // useEffect(() => {
  //   try {
  //     validateForm.validateSync(
  //       { ...structuredClone(profileDetails), profile },
  //       { abortEarly: false }
  //     );
  //     setErrors({});
  //   } catch (err) {
  //     setErrors(
  //       err.inner?.reduce(
  //         (acc, curr) => ({ ...acc, [curr.path]: curr.message }),
  //         {}
  //       ) ?? {}
  //     );
  //   }
  // }, [profileDetails, profile]);

  const handleChange = (e, type, key) => {
    const { name, value, checked } = e.target;
    if (type === "personalWebsites") {
      const clone = JSON.parse(JSON.stringify(commonAddFields));
      const val = clone[type]?.map((lan) =>
        lan.id == e.target.name
          ? { ...lan, value: e.target.value, error: "" }
          : lan
      );
      clone[type] = val;
      return setCommonAddFields(clone);
    }

    if (socialPlatforms.indexOf(name) > -1) {
      setUrlError({ ...urlErrors, [name]: "" });
    }

    if (type === "languagesKnown") {
      if (profileDetails?.[name]?.[0] === "") {
        return setProfileDetails({ ...profileDetails, [name]: [value] });
      } else {
        if (profileDetails?.languagesKnown?.includes(value)) {
          return setProfileDetails({ ...profileDetails });
        }
        return setProfileDetails({
          ...profileDetails,
          [name]: [...profileDetails?.[name], value],
        });
      }
    }

    if (name === phoneField) {
      if(value) {
        validateFields({
          ...profileDetails,
          [name]: validatePhoneNumber(value),
        })
      }

      return setProfileDetails({
        ...profileDetails,
        [name]: validatePhoneNumber(value),
      });
    }
    if (name === "pincode") {
      return setProfileDetails({
        ...profileDetails,
        [name]: validatePhoneNumber(value),
      });
    }
    if (type === "professionalPresence") {
      const cloneProfileDetails = [...profileDetails?.professionalPresence];
      const ChangeProfilePresence = cloneProfileDetails?.map((item) =>
        item.professionalKey === name
          ? { ...item, [key]: key === "link" ? value : checked, error: "" }
          : item
      );
      return setProfileDetails({
        ...profileDetails,
        professionalPresence: ChangeProfilePresence,
      });
    }
    if (type === "state" && value) {
      profileDetails.city = StateJson?.[profileDetails?.state]?.[0];
    }
    if (name === "professionalSummary") {
      let summaryLength = value.trim().split(" ").length >= 500;
      if (!summaryLength) {
        return setProfileDetails({ ...profileDetails, [name]: value });
      } else {
        return setProfileDetails({
          ...profileDetails,
          [name]: value.trim().split(" ").slice(0, 500).join(" "),
        });
      }
    }
    const updatedData = { ...profileDetails, [name]: value }
    if(value) {
      validateFields(updatedData)
    }
    return setProfileDetails(updatedData);
  };
  
  const handleChangeRadioButton = (e, type) => {
    const { name, id } = e.target;
    setProfileDetails({ ...profileDetails, [name]: id });
  };

  useEffect(() => {
    const personalWebsiteList = commonAddFields.personalWebsites.filter(
      (web) => web.value !== ""
    );
    setProfileDetails({
      ...profileDetails,
      // languagesKnown: commonAddFields.languagesKnown?.map((v) => v.value),
      personalWebsites: personalWebsiteList?.map((v) => v.value),
    });
    // eslint-disable-next-line
  }, [commonAddFields]);
  useEffect(() => {
    if (profileDetails?.secondaryEmail?.length > 0) {
      return setDisabled(
        !(
          profileDetails?.fullname &&
          validateEmail(profileDetails?.primaryEmail) &&
          validateEmail(profileDetails?.secondaryEmail) &&
          profileDetails?.phoneNumber?.toString()?.length === 10 &&
          profileDetails?.languagesKnown?.[0]?.length > 0 &&
          profileDetails?.personalWebsites?.[0]?.length > 0 &&
          profileDetails?.city &&
          profileDetails?.gender &&
          profileDetails?.twitter &&
          profileDetails?.facebook &&
          profileDetails?.dribble &&
          profileDetails?.instagram &&
          profileDetails?.vimeo
        )
      );
    }
    return setDisabled(
      !(
        profileDetails?.fullname &&
        validateEmail(profileDetails?.primaryEmail) &&
        profileDetails?.phoneNumber?.toString()?.length === 10 &&
        profileDetails?.languagesKnown?.[0]?.length > 0 &&
        profileDetails?.personalWebsites?.[0]?.length > 0 &&
        profileDetails?.city &&
        profileDetails?.gender &&
        profileDetails?.twitter &&
        profileDetails?.facebook &&
        profileDetails?.dribble &&
        profileDetails?.instagram &&
        profileDetails?.vimeo
      )
    );
    // eslint-disable-next-line
  }, [profileDetails]);
  const handleImageModalClose = () => {
    setOpenWebcam(false);
    setUploadedImage("");
    setWebcamImage("");
    // setFormError({ profile: '' })
    setOpenImageUpload(false);
    dispatch({ type: SHOW_ERROR, payload: { message: "", type: "" } });
  };

  const handleGoback = () => {
    refetch();
    window.scroll({ top: 0, behavior: "smooth" });
    setActiveTab("personal");
  };

  const onTabClick = (tabName) => {
    if (openTab.includes(tabName)) {
      setActiveTab(tabName);
    }
  };

  const handlePreview = (e) => {
    e.preventDefault();
    navigate("/profilePreview");
  };

  const handleUpdateProfilepic = async () => {
    if (imageFile != profile) {
      const formData = new FormData();
      if (webcamImage) {
        formData.append("baseFile", webcamImage);
      } else {
        formData.append("file", imageFile);
      }
      dispatch({ type: "SET_LOADER_STATUS", loading: true });
      setUploadedImage(null);
      setOpenWebcam(false);
      setOpenImageUpload(false);
      setProfile(null);
      setSamplesUpload(false);
      setWebcamImage("");

      dispatch({ type: "SET_LOADER_STATUS", loading: true });
      const imgResp = await UploadMedia(formData);
      if (imgResp.status === 200 && imgResp.data.url) {
        await setProfile(imgResp.data.url);
        validateFields(profileDetails, imgResp.data.url)
      }

      dispatch({ type: "SET_LOADER_STATUS", loading: false });
    }

    setOpenImageUpload(false);
  };

  const handlePresenceChange = (e) => {
    const { name, value, checked, type } = e.target;
    let clonedDetails = JSON.parse(JSON.stringify(profileDetails));
    clonedDetails.socialLinks = clonedDetails.socialLinks
      ? clonedDetails.socialLinks
      : [];
    const socialRecord = clonedDetails.socialLinks.find(
      (a) => a.professionalKey === name
    );
    const isCheckbox = type === "checkbox";
    if (socialRecord) {
      socialRecord[isCheckbox ? "subscribe" : "link"] = isCheckbox
        ? checked
        : value;
      socialRecord.error = "";
    } else {
      clonedDetails.socialLinks = [
        ...clonedDetails.socialLinks,
        {
          professionalKey: name,
          link: isCheckbox ? "" : value,
          subscribe: isCheckbox ? checked : false,
        },
      ];
    }
    setUrlError({
      ...urlErrors,
      [name]: "",
    });
    setProfileDetails(clonedDetails);
  };

  // const handleContinue = (e) => {
  //   const formType = e.target.getAttribute('form');
  //   const detailsForm = document.getElementById(formType);
  //   if(detailsForm.checkValidity()) {
  //     handleSubmitAboutTab(e)
  //   } else {
  //     const cloneDetails = JSON.parse(JSON.stringify(profileDetails));
  //     var cloneError = JSON.parse(JSON.stringify(urlErrors));
  //     socialPlatforms.map(platForm => {
  //       if(cloneDetails[platForm] && !checkUrl(cloneDetails[platForm])) {
  //         cloneError  = {...cloneError, [platForm]: "Please enter valid URL."}
  //       }
  //     })
  //     cloneDetails.professionalPresence.map((preference => {
  //       if(preference.link && !checkUrl(preference.link)) {
  //         preference.error = "Please enter valid URL."
  //       }
  //     }))

  //     setProfileDetails(cloneDetails);
  //     setUrlError(cloneError);
  //     window.scrollTo({top: 0, behavior: 'smooth'});
  //   }
  // }

  const handleContinue = (e) => {
    const formType = e.target.getAttribute("form");
    const detailsForm = document.getElementById(formType);
    const cloneDetails = JSON.parse(JSON.stringify(profileDetails));
    let cloneError = JSON.parse(JSON.stringify(urlErrors));

    if (detailsForm.checkValidity()) {
      let ValidpersonalWebsites = cloneDetails.personalWebsites.map((web) => {
        const clonecommonAddFields = JSON.parse(
          JSON.stringify(commonAddFields)
        );
        if (!ProfessionalUrlCheck(web)) {
          const WrongUrl = clonecommonAddFields.personalWebsites.map((item) =>
            item.value === web
              ? { ...item, error: "Please add a valid url" }
              : item
          );
          setCommonAddFields({
            ...commonAddFields,
            personalWebsites: WrongUrl,
          });
          return false;
        } else {
          const ValidUrl = clonecommonAddFields.personalWebsites.map((item) =>
            item.value === web && item.error ? { ...item, error: "" } : item
          );
          setCommonAddFields({
            ...commonAddFields,
            personalWebsites: ValidUrl,
          });
          return true;
          // handleSubmitAboutTab(e)
        }
      });
      cloneDetails.professionalPresence.map((preference) => {
        if (preference.link && !ProfessionalUrlCheck(preference.link)) {
          preference.error = "Please enter valid URL.";
        }
      });
      cloneDetails.socialLinks?.map((link) => {
        if (link.link && !ProfessionalUrlCheck(link.link)) {
          link.error = "Please enter valid URL.";
          cloneError[link.professionalKey] = "Please enter valid URL.";
        }
      });

      let getSocialLink =
        cloneDetails?.socialLinks?.length > 0
          ? cloneDetails?.socialLinks?.filter((item) => item.link !== "")
          : [];
      let validSocialLink = getSocialLink?.map((item) =>
        item.error ? false : true
      );
      let getProfessionalLink = cloneDetails.professionalPresence?.filter(
        (item) => item.link !== ""
      );
      let validprofessionalPresence = getProfessionalLink?.map((item) =>
        item.error ? false : true
      );

      if (validprofessionalPresence.includes(false)) {
        setProfileDetails(cloneDetails);
      }

      if (validSocialLink.includes(false)) {
        setUrlError(cloneError);
      }
      let AllURL = ValidpersonalWebsites.concat(
        validSocialLink,
        validprofessionalPresence
      );
      if (AllURL.includes(false)) {
        return;
      } else {
        handleSubmitAboutTab(e);
      }
    } else {
      socialPlatforms.map((platForm) => {
        if (cloneDetails[platForm] && !checkUrl(cloneDetails[platForm])) {
          cloneError = { ...cloneError, [platForm]: "Please enter valid URL." };
        }
      });
      cloneDetails.professionalPresence.map((preference) => {
        if (preference.link && !checkUrl(preference.link)) {
          preference.error = "Please enter valid URL.";
        }
      });
      setProfileDetails(cloneDetails);
      setUrlError(cloneError);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const closeSavedModal = () => {
    setSavedModal(false);
  };

  const handleRedirect = (e) => {
    e.preventDefault();
    localStorage.clear();
    // dispatch({ type: "LOGOUT_STATUS_SUCCESS" });
    window.navigation.navigate(SERVER_URL);
  };

  const handleLogout = () => {
    // localStorage.clear();
    dispatch({ type: "LOGOUT_STATUS_SUCCESS" });
  };

  return (
    <>
      <div className="text-start">
        <SavedModal handleClose={closeSavedModal} show={savedModal} />
        <Header />
        <div class="centerSection">
          <div class="containWrap">
            <div class="pageMsg">
              <p>
                BUILD YOUR PROFILE TO FIND THE RIGHT OPPORTUNITIES <span></span>{" "}
                SHOW THE CUSTOMERS YOU ARE THE ONE THEY WANT
              </p>
            </div>
            {/* Header start */}

            <div className="boxHeader">
              <div>
                <div class="boxStep">
                  <ul>
                    <li
                    // onClick={() => setActiveTab("personal")}
                    >
                      <div
                        className={
                          activeTab === "personal"
                            ? "stepName active"
                            : "stepName"
                        }
                      >
                        1. Personal Details
                      </div>
                    </li>
                    <li>
                      <b class="icon-arrow-right"></b>
                    </li>
                    <li
                    // onClick={() => setActiveTab("Services")}
                    >
                      <div
                        className={
                          activeTab === "Services"
                            ? "stepName active"
                            : "stepName"
                        }
                      >
                        2. Services
                      </div>
                    </li>
                    {/* <li>
                    <b class="icon-arrow-right"></b>
                  </li>
                  <li 
                  // onClick={() => setActiveTab("PaymentSetup")}
                    >
                    <div
                      className={
                        activeTab === "PaymentSetup"
                          ? "stepName active"
                          : "stepName"
                      }
                    >
                      3. Payment Setup
                    </div>
                  </li> */}
                  </ul>
                </div>
                <div class="boxDone">
                  <p>Profile Completion</p>
                  <div class="progressWrap">
                    <div class="progressBar">
                      <div
                        class="progressReal"
                        style={
                          activeTab === "personal"
                            ? { width: "50%" }
                            : { width: "100%" }
                        }
                      ></div>
                    </div>
                  </div>
                  <span> {activeTab === "personal" ? "50% " : "100%"}</span>
                </div>
              </div>
              <div className="text-end mb-4 d-flex align-items-center">
                {/* {!profileDetails?.isSetupProfile ? ( */}
                  <>
                    {activeTab === "personal" ? (
                      <span className="me-4">
                        <Button
                          className="button"
                          title="SAVE"
                          id="Save"
                          form={
                            activeTab === "personal"
                              ? "personal_details"
                              : "services"
                          }
                          type={activeTab === "personal" ? "btn" : "submit"}
                          handleClick={(e) => handleContinue(e)}
                        />
                      </span>
                    ) : (
                      <Button
                        className="button"
                        title="SAVE"
                        id="Save"
                        form={
                          activeTab === "personal"
                            ? "personal_details"
                            : "services"
                        }
                        type="submit"
                      />
                    )}

                    {/* {!profileDetails?.isSetupProfile ? ( */}
                      <>
                        {activeTab === "Services" && (
                          <Button
                            type="submit"
                            id="PreviewProfile"
                            form="services"
                            className="button me-4"
                            title="Preview Profile"
                          />
                        )}

                        {activeTab === "Services" && (
                          <Button
                            type="submit"
                            form="services"
                            id="PublishProfile"
                            className="button button-primary"
                            placement="auto"
                            // toolTipMessage={isPublishable(profileDetails) ? "" : unPublishToolTip}
                            // disabled={!isPublishable(profileDetails)}
                            title="Publish Profile"
                          />
                        )}
                      </>
                    {/* ) : ( */}
                      {/* <div className="text-center" style={{ margin: "20px 0" }}>
                        <Link
                          to="/vendordashboard"
                          onClick={(e) => handleRedirect(e)}
                          className="link text-decoration-none f-700"
                        >
                          HOME
                        </Link>
                      </div> */}
                    {/* )} */}

                    {activeTab === "personal" && (
                      <Button
                        // type="submit"
                        form="personal_details"
                        id="Continue"
                        title="Continue"
                        handleClick={(e) => handleContinue(e)}
                        className="button button-primary profile_continue_button"
                      />
                    )}
                  </>
                {/* ) : ( */}
                  {/* <div className="text-center" style={{ margin: "20px 0" }}>
                    <Link
                      to="/vendordashboard"
                      onClick={(e) => handleRedirect(e)}
                      className="link text-decoration-none f-700"
                    >
                      HOME
                    </Link>
                  </div> */}
                {/* )} */}
                {/* <Link to="#" className="link ms-4 logout-dropdown_container">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic" variant="standard">
                      <i className="fa fa-ellipsis-v"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => handleLogout()}
                        href="#/action-1"
                      >
                        <img src={Logout} alt="logout" className="me-2" />
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Link> */}
                <Link to="#" className="link ms-4 fs-18" onClick={() => handleLogout()}>Log Out</Link>
              </div>
            </div>
            {/* Header End */}

            {/* Content Start */}
            {activeTab === "personal" && (
              <Form
                id="personal_details"
                onSubmit={(e) => handleSubmitAboutTab(e)}
              >
                <About
                  errors={errors}
                  handleSelectChange={handleSelectChange}
                  setOpenTab={setOpenTab}
                  urlErrors={urlErrors}
                  profileDetails={profileDetails}
                  TabsHeading={TabsHeading}
                  handleChange={handleChange}
                  handleChangeRadioButton={handleChangeRadioButton}
                  openTab={openTab}
                  setProfileDetails={setProfileDetails}
                  commonAddFields={commonAddFields}
                  setCommonAddFields={setCommonAddFields}
                  profile={profile}
                  hiddenFileInput={hiddenFileInput}
                  handleUploadImage={handleUploadImage}
                  handleSubmitAboutTab={handleSubmitAboutTab}
                  capture={capture}
                  webcamRef={webcamRef}
                  webcamImage={webcamImage}
                  setWebcamImage={setWebcamImage}
                  openWebcam={openWebcam}
                  setOpenWebcam={setOpenWebcam}
                  handleWebcam={handleWebcam}
                  uploadedImage={uploadedImage}
                  setUploadedImage={setUploadedImage}
                  imageDisplayModalOpen={imageDisplayModalOpen}
                  setImageDisplayModalOpen={setImageDisplayModalOpen}
                  handleImageModalClose={handleImageModalClose}
                  handleImageSubmit={handleUpdateProfilepic}
                  setOpenImageUpload={setOpenImageUpload}
                  openImageUpload={openImageUpload}
                  phone={phone}
                />
                <SocialPresence
                  disabled={disabled}
                  profileDetails={profileDetails}
                  urlErrors={urlErrors}
                  handleChange={handleChange}
                  handleSocialChange={handlePresenceChange}
                  setProfileDetails={setProfileDetails}
                  handleSubmit={handleSubmitAboutTab}
                />
                {/* {!profileDetails?.isSetupProfile ? ( */}
                  <div className="text-center boxFooter">
                    <span className="me-4">
                      <Button
                        className="button"
                        title="SAVE"
                        form={
                          activeTab === "personal"
                            ? "personal_details"
                            : "services"
                        }
                        type={activeTab === "personal" ? "btn" : "submit"}
                        handleClick={(e) => handleContinue(e)}
                      />
                    </span>
                    <Button
                      // type="submit"
                      form="personal_details"
                      id="Continue"
                      title="Continue"
                      handleClick={(e) => handleContinue(e)}
                      className="button button-primary profile_continue_button"
                    />
                  </div>
                {/* ) : ( */}
                  {/* <div className="text-center" style={{ margin: "20px 0" }}>
                    <Link
                      to="/vendordashboard"
                      onClick={(e) => handleRedirect(e)}
                      className="link text-decoration-none f-700"
                    >
                      HOME
                    </Link>
                  </div> */}
                {/* )} */}
              </Form>
            )}
            {activeTab === "Services" && (
              <>
                <Services
                  errors={errors}
                  openTab={openTab}
                  setProfileDetails={setProfileDetails}
                  setSavedModal={setSavedModal}
                  setOpenTab={setOpenTab}
                  TabsHeading={TabsHeading}
                  token={token}
                  decodedId={id}
                  setActiveTab={setActiveTab}
                  servicesOffered={servicesOffered}
                  setServicesOffered={setServicesOffered}
                  services={services}
                  setServices={setServices}
                  servicesCount={servicesCount}
                  setServicesCount={setServicesCount}
                  handleGoback={handleGoback}
                  imageDisplayModal={imageDisplayModal}
                  setImageDisplayModal={setImageDisplayModal}
                  UploadMedia={UploadMedia}
                  currentService={currentService}
                  setCurrentService={setCurrentService}
                  samplesUpload={samplesUpload}
                  setSamplesUpload={setSamplesUpload}
                  appendURL={appendURL}
                  DeleteMedia={DeleteMedia}
                  DeletePancard={DeletePancard}
                  refetch={refetch}
                  profileDetails={profileDetails}
                />
              </>
            )}
            {activeTab === "PaymentSetup" && (
              <PaymentSetup
                openTab={activeTab}
                TabsHeading={["PaymentSetup"]}
              />
            )}
          </div>
        </div>
        <UpArrowQuestion />
      </div>
    </>
  );
};

export default ProfileSetup;
